import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { GalleryDto, GalleryInvitation, GalleryMemberAccess } from '@nusign/picflow-backend-types';
import { catchError, of } from 'rxjs';
import { BadgeComponent } from '../../../components/badge/badge.component';
import { GalleryAccessLevel } from '../../../lib/access-level';
import { GalleryMemberService } from '../../../services/gallery-member.service';
import { GalleryShareContextComponent } from '../../../shared-extra/components/gallery-share-context/gallery-share-context.component';
import { AccessItemBodyComponent } from '../access-item-body/access-item-body.component';
import { AccessItemCtaComponent } from '../access-item-cta/access-item-cta.component';
import { AccessItemHeaderComponent } from '../access-item-header/access-item-header.component';
import { AccessItemComponent } from '../access-item/access-item.component';

@Component({
  selector: 'app-gallery-invite-access-item',
  imports: [
    GalleryShareContextComponent,
    AccessItemComponent,
    AccessItemHeaderComponent,
    AccessItemBodyComponent,
    AccessItemCtaComponent,
    BadgeComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './gallery-invite-access-item.component.html',
  styleUrl: './gallery-invite-access-item.component.scss',
})
export class GalleryInviteAccessItemComponent {
  private galleryMemberService = inject(GalleryMemberService);
  invite = input.required<GalleryInvitation>();
  inviteAccess = input.required<GalleryAccessLevel>();
  galleryPermissions = input.required<GalleryDto['permissions']>();
  inviteAccessLevels: 'remove'[] = ['remove'];

  changeInviteAccessLevel(newAccessLevel: GalleryMemberAccess | 'remove') {
    if (newAccessLevel === 'remove') {
      this.galleryMemberService
        .removeInvite(this.invite().id)
        .pipe(
          catchError(err => {
            if (!(err instanceof HttpErrorResponse)) throw err;
            if (err.status !== 404 && err.status !== 403 && err.status !== 401) throw err;
            // Member was already removed
            return of(undefined);
          })
        )
        .subscribe();
    }
  }
}
